// extracted by mini-css-extract-plugin
export default {"favorite":"favorite_favorite__PwWYx","favorite__title":"favorite_favorite__title__dXFb6","favorite__wrapper":"favorite_favorite__wrapper__FxmZU"};